module.exports = __webpack_public_path__ + "img/connections-circles.455bcff4.png";